define('webui-base/js/decorator/main', ['require', 'exports', 'module', 'webui-base/js/decorator/trace-unmount-component', 'webui-base/js/decorator/sb-component', 'webui-base/js/decorator/route-component', 'webui-base/js/decorator/dialog-component', 'webui-base/js/decorator/form-util-component', 'webui-base/js/decorator/need-perm-component'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.needPermComponent = exports.formUtilComponent = exports.dialogComponent = exports.routeComponent = exports.sbComponent = exports.traceUnmountComponent = undefined;

var _traceUnmountComponent = require('webui-base/js/decorator/trace-unmount-component');

var _traceUnmountComponent2 = babelHelpers.interopRequireDefault(_traceUnmountComponent);

var _sbComponent = require('webui-base/js/decorator/sb-component');

var _sbComponent2 = babelHelpers.interopRequireDefault(_sbComponent);

var _routeComponent = require('webui-base/js/decorator/route-component');

var _routeComponent2 = babelHelpers.interopRequireDefault(_routeComponent);

var _dialogComponent = require('webui-base/js/decorator/dialog-component');

var _dialogComponent2 = babelHelpers.interopRequireDefault(_dialogComponent);

var _formUtilComponent = require('webui-base/js/decorator/form-util-component');

var _formUtilComponent2 = babelHelpers.interopRequireDefault(_formUtilComponent);

var _needPermComponent = require('webui-base/js/decorator/need-perm-component');

var _needPermComponent2 = babelHelpers.interopRequireDefault(_needPermComponent);

exports.traceUnmountComponent = _traceUnmountComponent2.default;
exports.sbComponent = _sbComponent2.default;
exports.routeComponent = _routeComponent2.default;
exports.dialogComponent = _dialogComponent2.default;
exports.formUtilComponent = _formUtilComponent2.default;
exports.needPermComponent = _needPermComponent2.default;
});

define('webui-base/js/decorator/trace-unmount-component', ['require', 'exports', 'module', 'react-mixin'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactMixin = require('react-mixin');

var _reactMixin2 = babelHelpers.interopRequireDefault(_reactMixin);

var mixin = {
  componentWillUnmount: function componentWillUnmount() {
    this._unmounted = true;
  }
};

var traceUnmountComponent = function traceUnmountComponent(Wrapped) {
  var _dec, _class;

  return _dec = _reactMixin2.default.decorate(mixin), _dec(_class = function (_Wrapped) {
    babelHelpers.inherits(TraceUnmountComponent, _Wrapped);

    function TraceUnmountComponent() {
      babelHelpers.classCallCheck(this, TraceUnmountComponent);
      return babelHelpers.possibleConstructorReturn(this, (TraceUnmountComponent.__proto__ || Object.getPrototypeOf(TraceUnmountComponent)).apply(this, arguments));
    }

    return TraceUnmountComponent;
  }(Wrapped)) || _class;
};

exports.default = traceUnmountComponent;
});

define('webui-base/js/decorator/sb-component', ['require', 'exports', 'module', 'skateboardjs', 'util', 'webui-base/js/decorator/trace-unmount-component'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _skateboardjs = require('skateboardjs');

var _skateboardjs2 = babelHelpers.interopRequireDefault(_skateboardjs);

var _util = require('util');

var _traceUnmountComponent = require('webui-base/js/decorator/trace-unmount-component');

var _traceUnmountComponent2 = babelHelpers.interopRequireDefault(_traceUnmountComponent);

var sbComponent = function sbComponent(Wrapped) {
  var _class;

  return (0, _traceUnmountComponent2.default)(_class = function (_Wrapped) {
    babelHelpers.inherits(SbComponent, _Wrapped);

    function SbComponent(props) {
      babelHelpers.classCallCheck(this, SbComponent);

      var _this = babelHelpers.possibleConstructorReturn(this, (SbComponent.__proto__ || Object.getPrototypeOf(SbComponent)).call(this, props));

      _this.isSbComponent = true;

      _this._updatedProps = null;
      _this._speedReporter = new Stat.SpeedReporter(_skateboardjs2.default.core.getViewChangeInfo().time);
      return _this;
    }

    babelHelpers.createClass(SbComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!G.NO_NEED_PERM && !this.needPerm) {
          var path = this.props.route.path;
          _util.Alerts.dev('Please set permission for route "' + path + '"');
        }
        babelHelpers.get(SbComponent.prototype.__proto__ || Object.getPrototypeOf(SbComponent.prototype), 'componentDidMount', this) && babelHelpers.get(SbComponent.prototype.__proto__ || Object.getPrototypeOf(SbComponent.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'onSbUpdate',
      value: function onSbUpdate(props) {
        this._updatedProps = props;
        babelHelpers.get(SbComponent.prototype.__proto__ || Object.getPrototypeOf(SbComponent.prototype), 'onSbUpdate', this) && babelHelpers.get(SbComponent.prototype.__proto__ || Object.getPrototypeOf(SbComponent.prototype), 'onSbUpdate', this).call(this, props);
      }
    }, {
      key: 'getSearchParams',
      value: function getSearchParams(props) {
        props = props || this._updatedProps || this.props;
        return props.route.params;
      }
    }, {
      key: 'getFullPath',
      value: function getFullPath(props) {
        props = props || this._updatedProps || this.props;
        return props.route.mark;
      }
    }, {
      key: 'statSpeed',
      value: function statSpeed() {
        var _speedReporter;

        (_speedReporter = this._speedReporter).speed.apply(_speedReporter, arguments);
      }
    }, {
      key: 'gotoAlert',
      value: function gotoAlert(msg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'error' : _ref$type,
            _ref$holdMark = _ref.holdMark,
            holdMark = _ref$holdMark === undefined ? true : _ref$holdMark,
            _ref$noReturn = _ref.noReturn,
            noReturn = _ref$noReturn === undefined ? holdMark : _ref$noReturn,
            _ref$retry = _ref.retry,
            retry = _ref$retry === undefined ? type == 'error' : _ref$retry;

        _util.Route.push('/public/alert', null, {
          holdMark: holdMark,
          modOpt: {
            type: type,
            msg: msg,
            noReturn: noReturn,
            retry: retry
          }
        });
      }
    }, {
      key: 'sbModInst',
      get: function get() {
        return this.props.sbModInst;
      }
    }, {
      key: 'searchParams',
      get: function get() {
        return this.getSearchParams();
      }
    }, {
      key: 'fullPath',
      get: function get() {
        return this.getFullPath();
      }
    }]);
    return SbComponent;
  }(Wrapped)) || _class;
};

exports.default = sbComponent;
});

define('webui-base/js/decorator/route-component', ['require', 'exports', 'module', 'react', 'classnames', 'util', 'webui-base/js/decorator/trace-unmount-component', 'lang/' + G.LANG + '/app.json'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

var _util = require('util');

var _traceUnmountComponent = require('webui-base/js/decorator/trace-unmount-component');

var _traceUnmountComponent2 = babelHelpers.interopRequireDefault(_traceUnmountComponent);

var _app = require('lang/' + G.LANG + '/app.json');

var _app2 = babelHelpers.interopRequireDefault(_app);

var routeComponent = function routeComponent(Wrapped) {
  var _class;

  return (0, _traceUnmountComponent2.default)(_class = function (_Wrapped) {
    babelHelpers.inherits(RouteComponent, _Wrapped);

    function RouteComponent(props) {
      babelHelpers.classCallCheck(this, RouteComponent);

      var _this = babelHelpers.possibleConstructorReturn(this, (RouteComponent.__proto__ || Object.getPrototypeOf(RouteComponent)).call(this, props));

      _this._lastRouteChange = _util.Route.lastChange;
      _this._speedReporter = new Stat.SpeedReporter(_util.Route.lastChange.time);
      return _this;
    }

    babelHelpers.createClass(RouteComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!G.NO_NEED_PERM && !this.needPerm) {
          var path = this.props.route.path || this.props.route._path;
          _util.Alerts.dev('Please set permission for route "' + path + '"');
        }
        if (this.title) {
          document.title = this.title + ' - ' + _app2.default.label.appName;
        } else {
          var props = this.props;
          // leaf
          if (props.routes.indexOf(props.route) == props.routes.length - 1) {
            document.title = _app2.default.label.appName;
            if ("production" !== 'production') {
              _util.Alerts.dev('please define title for this page');
            }
          }
        }
        babelHelpers.get(RouteComponent.prototype.__proto__ || Object.getPrototypeOf(RouteComponent.prototype), 'componentDidMount', this) && babelHelpers.get(RouteComponent.prototype.__proto__ || Object.getPrototypeOf(RouteComponent.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'getSearchParams',
      value: function getSearchParams(props) {
        props = props || this.props;
        return (0, _util.getSearchParams)(props.location && props.location.search || '');
      }
    }, {
      key: 'getFullPath',
      value: function getFullPath(props) {
        props = props || this.props;
        var loc = props.location;
        if (!loc) {
          return '';
        }
        return loc.pathname + loc.search + loc.hash;
      }
    }, {
      key: 'statSpeed',
      value: function statSpeed() {
        var _speedReporter;

        (_speedReporter = this._speedReporter).speed.apply(_speedReporter, arguments);
      }
    }, {
      key: 'render',
      value: function render() {
        var ele = babelHelpers.get(RouteComponent.prototype.__proto__ || Object.getPrototypeOf(RouteComponent.prototype), 'render', this).call(this);
        if (!ele) {
          return null;
        }
        var cns = this.classNames;
        if (ele.props && ele.props.className) {
          ele.props.className.split(/\s+/).forEach(function (c) {
            return c && (cns[c] = true);
          });
        }
        return _react2.default.cloneElement(ele, { className: (0, _classnames2.default)(cns) });
      }
    }, {
      key: 'classNames',
      get: function get() {
        var res = {};
        var s = this.props.routes.indexOf(this.props.route);
        res[this.props.routes.reduce(function (prev, route, i) {
          route = _util.Route.denormalizeIndexRoute(route);
          var next = prev;
          if (i > s) {
            return next;
          }
          var p = route.path.replace(/^\/+/, '').replace(/\*/g, '_').replace(/[()]/g, '').replace(/\/+:/g, '-_').replace(/\/+/g, '-');
          if (p) {
            next += (next == 'app-module' ? '__' : '--') + p;
          }
          return next;
        }, 'app-module')] = true;
        this.props.routes.reduce(function (prev, route, i) {
          route = _util.Route.denormalizeIndexRoute(route);
          var next = prev;
          if (next) {
            next += (next == 'route' ? '__' : '--') + route.path.replace(/\*/g, '_').replace(/[()]/g, '').replace(/\/+:/g, '-_').replace(/\/+/g, '-');
            if (i > s) {
              res[next] = true;
            }
          } else {
            next = 'route';
          }
          return next;
        }, '');
        if (this.props.className) {
          this.props.className.split(/\s+/).forEach(function (c) {
            return c && (res[c] = true);
          });
        }
        if (!this.props.children) {
          res['no-route-component-children'] = true;
        }
        return babelHelpers.extends({}, babelHelpers.get(RouteComponent.prototype.__proto__ || Object.getPrototypeOf(RouteComponent.prototype), 'classNames', this), res);
      }
    }, {
      key: 'searchParams',
      get: function get() {
        return this.getSearchParams(this.props);
      }
    }, {
      key: 'fullPath',
      get: function get() {
        return this.getFullPath(this.props);
      }
    }]);
    return RouteComponent;
  }(Wrapped)) || _class;
};

exports.default = routeComponent;
});

define('webui-base/js/decorator/dialog-component', ['require', 'exports', 'module', 'core-decorators', 'util', 'webui-base/js/decorator/trace-unmount-component'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coreDecorators = require('core-decorators');

var _util = require('util');

var _traceUnmountComponent = require('webui-base/js/decorator/trace-unmount-component');

var _traceUnmountComponent2 = babelHelpers.interopRequireDefault(_traceUnmountComponent);

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var dialogComponent = function dialogComponent(Wrapped) {
  var _class, _desc, _value, _class2;

  return (0, _traceUnmountComponent2.default)(_class = (_class2 = function (_Wrapped) {
    babelHelpers.inherits(DialogComponent, _Wrapped);

    function DialogComponent() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, DialogComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = DialogComponent.__proto__ || Object.getPrototypeOf(DialogComponent)).call.apply(_ref, [this].concat(args))), _this), _this.isDialogComponent = true, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(DialogComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!G.NO_NEED_PERM && !this.needPerm) {
          _util.Alerts.dev('Please set permission for dialog "' + this.props.manager.name + '"');
        }
        babelHelpers.get(DialogComponent.prototype.__proto__ || Object.getPrototypeOf(DialogComponent.prototype), 'componentDidMount', this) && babelHelpers.get(DialogComponent.prototype.__proto__ || Object.getPrototypeOf(DialogComponent.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'closeDialog',
      value: function closeDialog() {
        _util.Dialog.close(this.props.manager.name);
      }
    }, {
      key: 'reportSpeed',
      value: function reportSpeed() {
        if (!this._speedReported) {
          var manager = this.props.manager;
          _util.Stat.speed(manager.name, new Date() - manager.openTime, 'd-s');
          this._speedReported = true;
        }
      }
    }]);
    return DialogComponent;
  }(Wrapped), (_applyDecoratedDescriptor(_class2.prototype, 'closeDialog', [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, 'closeDialog'), _class2.prototype)), _class2)) || _class;
};

exports.default = dialogComponent;
});

define('webui-base/js/decorator/form-util-component', ['require', 'exports', 'module', 'react', 'react-dom', 'classnames', 'bluebird', 'util'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

var _bluebird = require('bluebird');

var _bluebird2 = babelHelpers.interopRequireDefault(_bluebird);

var _util = require('util');

var UNDEFINED = Symbol('undefined');

var formUtilComponent = function formUtilComponent(Wrapped) {
  return function (_Wrapped) {
    babelHelpers.inherits(FormUtilComponent, _Wrapped);

    function FormUtilComponent(props) {
      babelHelpers.classCallCheck(this, FormUtilComponent);
      return babelHelpers.possibleConstructorReturn(this, (FormUtilComponent.__proto__ || Object.getPrototypeOf(FormUtilComponent)).call(this, props));
    }

    babelHelpers.createClass(FormUtilComponent, [{
      key: 'focusForm',
      value: function focusForm(node, select) {
        return new _bluebird2.default(function (resolve, reject) {
          formUtilComponent.getLangImport().then(function (YomFormUtil) {
            $('.has-error', node).closest('.panel-collapse').collapse('show');
            YomFormUtil.focus(node, select);
            resolve();
          }, reject);
        });
      }
    }, {
      key: 'highLight',
      value: function highLight(node, msg, type) {
        return new _bluebird2.default(function (resolve, reject) {
          formUtilComponent.getLangImport().then(function (YomFormUtil) {
            YomFormUtil.highLight(node, msg, type);
            resolve();
          }, reject);
        });
      }
    }, {
      key: 'dehighLight',
      value: function dehighLight(node) {
        return new _bluebird2.default(function (resolve, reject) {
          formUtilComponent.getLangImport().then(function (YomFormUtil) {
            YomFormUtil.dehighLight(node);
            resolve();
          }, reject);
        });
      }
    }, {
      key: 'publicValidateForm',
      value: function publicValidateForm() {
        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'publicValidateForm', this)) {
          return babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'publicValidateForm', this).call(this, opt);
        } else {
          return this.validateForm(opt);
        }
      }
    }, {
      key: 'validateForm',
      value: function validateForm() {
        var _this2 = this;

        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'validateForm', this)) {
          return babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'validateForm', this).call(this, opt);
        }
        return new _bluebird2.default(function (resolve, reject) {
          formUtilComponent.getLangImport().then(function (YomFormUtil) {
            var stdForm = opt.stdForm,
                emptyValue = opt.emptyValue;
            /* eslint-disable react/no-find-dom-node */

            var form = _this2.form || _reactDom2.default.findDOMNode(_this2);
            /* eslint-enable react/no-find-dom-node */
            var valid = YomFormUtil.validate(form, { stdForm: stdForm, emptyValue: emptyValue });
            if (_this2.getFormData) {
              valid.data = _this2.getFormData();
            }
            var subForms = [];
            for (var key in _this2.refs) {
              if (key.indexOf('formUtilComponent') === 0) {
                subForms.push(key);
              }
            }
            _bluebird2.default.all(subForms.map(function (key) {
              return _this2.refs[key].publicValidateForm(opt);
            }).concat(Object.keys(_this2._subFormUtilComponents).map(function (key) {
              return _this2._subFormUtilComponents[key].publicValidateForm(opt) || { passed: true };
            }))).then(function (vs) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = vs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var v = _step.value;

                  valid.passed = valid.passed && v.passed;
                  valid.failList = valid.failList.concat(v.failList);
                  valid.helpList = valid.helpList.concat(v.helpList);
                  valid.data = babelHelpers.extends({}, valid.data, v.data);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (_this2.props.getFormData) {
                valid.data = _this2.props.getFormData(valid.data);
              }
              resolve(valid);
            }, function (err) {
              return reject(err);
            });
          }, reject);
        });
      }
    }, {
      key: 'validateInput',
      value: function validateInput(evt) {
        var node = evt.target.parentNode;
        formUtilComponent.getLangImport().then(function (YomFormUtil) {
          YomFormUtil.validate(node);
        });
      }
    }, {
      key: 'getSubFormUtilComponent',
      value: function getSubFormUtilComponent(key) {
        return this._subFormUtilComponents[key];
      }
    }, {
      key: 'setSubFormUtilComponent',
      value: function setSubFormUtilComponent(key) {
        var _this3 = this;

        return function (component) {
          if (component) {
            _this3._subFormUtilComponents[key || (0, _util.getAutoIncreasedId)()] = component;
          }
        };
      }
    }, {
      key: 'normalizeFormDataValue',
      value: function normalizeFormDataValue(val) {
        var _this4 = this;

        if (Array.isArray(val)) {
          val = val.map(function (item) {
            return _this4.normalizeFormDataValue(item);
          });
        }
        return val;
      }
    }, {
      key: 'normalizeFormData',
      value: function normalizeFormData(data) {
        var _this5 = this;

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            ignoreKeyTester = _ref.ignoreKeyTester;

        if (Object.prototype.toString.call(data) != '[object Object]') {
          return this.normalizeFormDataValue(data);
        }
        if (!data) {
          return data;
        }
        var res = {};

        var _loop = function _loop(key) {
          if (key.indexOf('.') < 0 || ignoreKeyTester && ignoreKeyTester(key)) {
            res[key] = _this5.normalizeFormDataValue(data[key]);
          } else {
            var keys = key.split('.');
            var len = keys.length;
            var ref = res;
            keys.forEach(function (k, i) {
              if (!/\D/.test(k)) {
                k = parseInt(k);
              }
              if (i == len - 1) {
                ref[k] = _this5.normalizeFormDataValue(data[key]);
              } else {
                if (!ref[k]) {
                  if (!/\D/.test(keys[i + 1])) {
                    ref[k] = [];
                  } else {
                    ref[k] = {};
                  }
                }
                ref = ref[k];
              }
            });
          }
        };

        for (var key in data) {
          _loop(key);
        }
        return res;
      }
    }, {
      key: 'validateOnInputChange',
      value: function validateOnInputChange(callback) {
        return function (evt) {
          var target = evt.currentTarget;
          formUtilComponent.getLangImport().then(function (YomFormUtil) {
            var valid = YomFormUtil.validateOne(target);
            if (valid.passed && callback) {
              callback(target.value);
            }
          });
        };
      }
    }, {
      key: 'syncState',
      value: function syncState(name) {
        var _this6 = this;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            extraState = _ref2.extraState,
            valueGetter = _ref2.valueGetter;

        return function () {
          var evt = arguments.length <= 0 ? undefined : arguments[0];
          var value = void 0;
          var target = evt && evt.target;
          name = name || target && target.name;
          if (!name) {
            return;
          }
          if (valueGetter) {
            value = valueGetter.apply(undefined, arguments);
          } else {
            if (target && target.tagName) {
              if (target.type == 'checkbox') {
                value = target.checked;
              } else {
                value = target.value;
              }
            } else {
              value = evt;
            }
            value = _this6.normalizeFormData(value);
          }
          var keys = name.split('.');
          if (keys.length > 1) {
            var state = _this6.state;
            while (keys.length > 1) {
              var key = keys.shift();
              state = state[key] = state[key] || {};
            }
            state[keys.shift()] = value;
            if (extraState) {
              $.extend(true, _this6.state, extraState);
            }
            _this6.forceUpdate();
          } else {
            var _state = {};
            _state[name] = value;
            if (extraState) {
              $.extend(_state, extraState);
            }
            _this6.setState(_state);
          }
        };
      }
    }, {
      key: 'onlyNumber',
      value: function onlyNumber() {
        return function (evt) {
          var keyCode = evt.keyCode;
          if (!(keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105 || keyCode == 8 || keyCode == 9 || keyCode == 13 || keyCode == 190 || keyCode == 110)) {
            evt.preventDefault();
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        this._subFormUtilComponents = {};
        var ele = babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'render', this).call(this);
        var cns = this.classNames;
        if (ele.props && ele.props.className) {
          ele.props.className.split(/\s+/).forEach(function (c) {
            return c && (cns[c] = true);
          });
        }
        return _react2.default.cloneElement(ele, { className: (0, _classnames2.default)(cns) });
      }
    }, {
      key: 'classNames',
      get: function get() {
        var res = { 'yom-form-util-component': true };
        if (this.props.className) {
          this.props.className.split(/\s+/).forEach(function (c) {
            return c && (res[c] = true);
          });
        }
        return babelHelpers.extends({}, babelHelpers.get(FormUtilComponent.prototype.__proto__ || Object.getPrototypeOf(FormUtilComponent.prototype), 'classNames', this), res);
      }
    }, {
      key: 'emptyValue',
      get: function get() {
        return formUtilComponent.getEmptyValue(this.props.emptyValue);
      }
    }]);
    return FormUtilComponent;
  }(Wrapped);
};

formUtilComponent.UNDEFINED = UNDEFINED;

formUtilComponent.getEmptyValue = function (emptyValue) {
  return typeof emptyValue == 'undefined' ? null : emptyValue == UNDEFINED ? undefined : emptyValue;
};

formUtilComponent.getLangImport = function (emptyValue) {
  return new _bluebird2.default(function (resolve, reject) {
    require(['yom-form-util'], function (module) {
      resolve(module);
    }, function (err) {
      reject(err);
    });
  }).then(function (module) {
    if (G.LANG === 'id-ID') {
      module.setCommonMsg({
        'datetime': 'Format datetime tidak valid',
        'domain': 'Nama domain tidak valid',
        'domain-list': 'Nama domain tidak valid',
        'email': 'Alamat email salah',
        'email-list': 'Alamat email salah',
        'integer': 'Harus memasukkan bilangan bulat',
        'integer-range': 'Nilai integer harus antara {{0}} dan {{1}}',
        'mandatory': 'Diperlukan input',
        'max-byte-length': 'Panjang input terlampaui, harap kurangi {{1}} karakter',
        'max-length': 'Panjang input terlampaui, harap kurangi {{1}} karakter',
        'mobile': 'Nomor ponsel tidak valid',
        'name': 'Salah nama',
        'number': 'Harus memasukkan nomor',
        'number-digits': 'Dicadangkan ke {{0}} tempat desimal',
        'number-range': 'Nilai angka harus antara {{0}} dan {{1}}',
        'password': 'Panjang kata sandi harus antara 6 dan 16. Kata sandi harus mengandung karakter alfabet huruf besar dan huruf kecil serta karakter numerik. Itu tidak boleh berisi ruang kosong.',
        'set': 'Nilai duplikat tidak diizinkan. Panjang maksimal nilai adalah 80, dan nilai tidak boleh mengandung \'||\'',
        'trim': 'Spasi di awal dan akhir tidak diperbolehkan',
        'url': 'URL tidak valid',
        'word-upper-case': 'Hanya huruf besar, digit atau garis bawah yang dibolehkan'
      });
    }
    return module;
  });
};

exports.default = formUtilComponent;
});

define('webui-base/js/decorator/need-perm-component', ['require', 'exports', 'module', 'util'], function (require, exports, module) {
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('util');

var needPermComponent = function needPermComponent(perm, type) {
  return function (Wrapped) {
    return function (_Wrapped) {
      babelHelpers.inherits(NeedPermComponent, _Wrapped);

      function NeedPermComponent() {
        var _ref;

        var _temp, _this, _ret;

        babelHelpers.classCallCheck(this, NeedPermComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = NeedPermComponent.__proto__ || Object.getPrototypeOf(NeedPermComponent)).call.apply(_ref, [this].concat(args))), _this), _this.needPerm = perm, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
      }

      babelHelpers.createClass(NeedPermComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (_util.Auth.Perm.has(perm, type)) {
            babelHelpers.get(NeedPermComponent.prototype.__proto__ || Object.getPrototypeOf(NeedPermComponent.prototype), 'componentDidMount', this) && babelHelpers.get(NeedPermComponent.prototype.__proto__ || Object.getPrototypeOf(NeedPermComponent.prototype), 'componentDidMount', this).call(this);
          } else if (perm == '_login_') {
            _util.Auth.logout();
          } else {
            var manager = this.props.manager;
            _util.Auth.Perm.redirect(manager && manager.dialogDOM ? 'dialog' : '');
          }
        }
      }, {
        key: 'hasPerm',
        value: function hasPerm(perm, type) {
          return _util.Auth.Perm.has(perm, type);
        }
      }]);
      return NeedPermComponent;
    }(Wrapped);
  };
};

exports.default = needPermComponent;
});